import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/styles/adminstudentprofile.css";

function AdminStudentProfile() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [student, setStudent] = useState({});
  const [attendance, setAttendance] = useState([]);
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    getStudent();
    getAttendance();
    getPayments();
  }, []);

  const getStudent = async () => {
    const res = await axios.get(`https://shuttle-craft-student-transport.onrender.com/api/students/${id}`);
    setStudent(res.data);
  };

  const getAttendance = async () => {
    const res = await axios.get(
      `https://shuttle-craft-student-transport.onrender.com/api/attendance/student/${id}`
    );
    setAttendance(res.data);
  };

  const getPayments = async () => {
    const res = await axios.get(
      `https://shuttle-craft-student-transport.onrender.com/api/payments/student/${id}`
    );
    setPayments(res.data);
  };

  const totalDays = attendance.length;

  const presentCount = attendance.filter((a) => a.status === "Present").length;

  const absentCount = attendance.filter((a) => a.status === "Absent").length;

  const totalPaid = payments.reduce((sum, p) => sum + p.amount, 0);

  return (
    <div className="admin-student-container">
  
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>
  
      <h2>Student Profile</h2>
  
      <div className="student-grid">
  
        <div className="card student-card">
          <h3>Student</h3>
          <p>{student.name}</p>
          <p>{student.phone}</p>
          <p>{student.batch}</p>
        </div>
  
        <div className="card attendance-card">
          <h3>Attendance</h3>
          <p>Total Days</p>
          <h2>{totalDays}</h2>
          <p>Present: {presentCount}</p>
          <p>Absent: {absentCount}</p>
        </div>
  
        <div className="card payment-card">
          <h3>Payments</h3>
          <p>Total Paid</p>
          <h2>₹ {totalPaid}</h2>
        </div>
  
      </div>
  
  
      <div className="history-section">
        <h3>Attendance History</h3>
  
        {attendance.length === 0 ? (
          <p>No attendance data</p>
        ) : (
          attendance.map((a, i) => (
            <p key={i}>
              {new Date(a.date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric"
              })} - {a.status}
            </p>
          ))
        )}
      </div>
  
  
      <div className="history-section">
        <h3>Payment History</h3>
  
        {payments.length === 0 ? (
          <p>No payments</p>
        ) : (
          payments.map((p, i) => (
            <p key={i}>
              {new Date(p.date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric"
              })} — ₹{p.amount}
            </p>
          ))
        )}
      </div>
  
    </div>
  );
}

export default AdminStudentProfile;
